import type { User } from "@/types";
import api from "./client";

export async function fetchUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>("/api/users");
  return data;
}

export interface PreferencesUpdateData {
  default_currency?: string;
  default_category_id?: string | null;
}

export async function updatePreferences(body: PreferencesUpdateData): Promise<User> {
  const { data } = await api.patch<User>("/api/users/me/preferences", body);
  return data;
}
